.whats-new {
    width: 100%;
}

.whats-new span[class*='body'] {
    color: var(--sidebar-primary);
}

.link {
    text-decoration: underline;
    color: var(--sidebar-primary);
}
